
const python = `
import time
import requests
import hmac
import json
from hashlib import sha256

APIURL = "PPRROOTTOOCCOOLL://HHOOSSTT"
APIKEY = ""
SECRETKEY = ""
TIMESTAMP=str(int(time.time() * 1000))
def demo():
    path = 'AAPPII'
    method = "MMEETTHHOODD"
    paramsMap = PPAAYYLLOOAADD
    paramsMap["timestamp"]=TIMESTAMP
    paramsStr = parseParam(paramsMap)
    return send_request(method, path, paramsStr, paramsMap)

def get_sign(api_secret, payload):
    signature = hmac.new(api_secret.encode("utf-8"), payload.encode("utf-8"), digestmod=sha256).hexdigest()
    return signature
def send_request(method, path, urlPa, payload):
    sign=get_sign(SECRETKEY, urlPa)
    print("urlPa:",urlPa)
    print("sign:",sign)
    payload['signature']=sign
    url = "%s%s" % (APIURL, path)
    print(url)
    headers = {
        'X-BX-APIKEY': APIKEY,
        'Content-Type': "application/json",
    }
    print(payload)
    response = requests.request(method, url, headers=headers, data=json.dumps(payload))
    return response.text

def parseParam(paramsMap):
    sortedKeys = sorted(paramsMap)
    paramsStr = "&".join(["%s=%s" % (x, paramsMap[x]) for x in sortedKeys])
    paramsStr = paramsStr.replace(" ", "")
    paramsStr = paramsStr.replace("'", '"')
    return paramsStr


if __name__ == '__main__':
    print( demo())`
export default python



// WEBPACK FOOTER //
// ./src/utils/codeJson/python.js